import React, { useEffect, useState } from 'react';
import { Dialog } from '@mui/material';
import { MdClose, MdAdd, MdDelete } from 'react-icons/md';

const SubscriptionPlanForm = ({ openDialog, handleClose, handleSubmit, loading, initialData = null }) => {
    const [formData, setFormData] = useState(
        initialData || {
            title: '',
            tags: [''],
            gst_persentage: null,
            duration: '',
            duration_in_days: null,
            main_price: null,
            selling_price: null,
            index: null,
            _id: null
        }
    );

    useEffect(() => {
        setFormData(initialData)
    }, [initialData])

    const updateField = (field, value) => {
        // Prevent setting a negative index
        if (field === 'index' && value < 0) return;

        setFormData((prev) => ({
            ...prev,
            [field]: value,
        }));
    };


    const updateTagValue = (index, value) => {
        const updatedTags = [...formData?.tags];
        updatedTags[index] = value;
        setFormData((prev) => ({
            ...prev,
            tags: updatedTags,
        }));
    };
    const addTagField = () => {
        if (!formData || !Array.isArray(formData.tags)) return;

        setFormData((prev) => ({
            ...prev,
            tags: [...prev.tags, ''],
        }));
    };


    const removeTagField = (index) => {
        const updatedTags = [...formData?.tags];
        updatedTags.splice(index, 1);
        setFormData((prev) => ({
            ...prev,
            tags: updatedTags,
        }));
    };

    const onSubmit = (e) => {
        e.preventDefault();
        handleSubmit(formData);
    };

    return (
        <Dialog
            open={openDialog}
            onClose={handleClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{ sx: { borderRadius: '16px' } }}
        >
            <form onSubmit={onSubmit}>
                <div className="card mb-0">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h6 className="card-title mb-0">{initialData ? 'Edit' : 'Add'} Subscription Plan</h6>
                        <button type="button" className="btn btn-sm btn-light p-1" onClick={handleClose}>
                            <MdClose size={18} />
                        </button>
                    </div>

                    <div className="card-body">
                        <div className="row gy-3">
                            <div className="col-md-6">
                                <label className="form-label">Title</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={formData?.title}
                                    onChange={(e) => updateField('title', e.target.value)}
                                />
                            </div>

                            <div className="col-md-6">
                                <label className="form-label">Index</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    value={formData?.index ?? ''}
                                    onChange={(e) => updateField('index', parseInt(e.target.value))}
                                />
                            </div>

                            <div className="col-md-6">
                                <label className="form-label">Duration</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={formData?.duration}
                                    onChange={(e) => updateField('duration', e.target.value)}
                                />
                            </div>

                            <div className="col-md-6">
                                <label className="form-label">Duration in Days</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    value={formData?.duration_in_days ?? ''}
                                    onChange={(e) => updateField('duration_in_days', parseInt(e.target.value))}
                                />
                            </div>

                            {/* <div className="col-md-6">
                                <label className="form-label">Main Price</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    value={formData?.main_price ?? ''}
                                    onChange={(e) => updateField('main_price', parseFloat(e.target.value))}
                                />
                            </div> */}

                            {/* <div className="col-md-6">
                                <label className="form-label">GST (%)</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    value={formData?.gst_persentage ?? ''}
                                    onChange={(e) => updateField('gst_persentage', parseFloat(e.target.value))}
                                />
                            </div> */}

                            <div className="col-md-6">
                                <label className="form-label">Selling Price</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    value={formData?.selling_price ?? ''}
                                    onChange={(e) => updateField('selling_price', parseFloat(e.target.value))}
                                />
                            </div>

                            <div className="col-12">
                                <label className="form-label">Tags</label>
                                <div className="d-flex flex-column gap-2">
                                    {formData?.tags?.map((tag, index) => (
                                        <div key={index} className="d-flex align-items-center gap-2">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder={`Tag ${index + 1}`}
                                                value={tag}
                                                onChange={(e) => updateTagValue(index, e.target.value)}
                                            />
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-danger"
                                                onClick={() => removeTagField(index)}
                                            >
                                                <MdDelete size={18} />
                                            </button>
                                        </div>
                                    ))}
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-primary mt-2"
                                        onClick={addTagField}
                                    >
                                        <MdAdd size={20} className="me-1" />
                                        Add Tag
                                    </button>
                                </div>
                            </div>

                            <div className="col-12 text-end">
                                <button type="button" className="btn btn-secondary me-2" onClick={handleClose}>
                                    Cancel
                                </button>
                                <button disabled={loading} type="submit" className="btn btn-primary">
                                    {loading ? <span className="spinner-border spinner-border-sm" /> : 'Save'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </Dialog>
    );
};

export default SubscriptionPlanForm;
